import { render } from "./PayslipLabelValueTable.vue?vue&type=template&id=527cdcec&scoped=true"
import script from "./PayslipLabelValueTable.vue?vue&type=script&lang=js"
export * from "./PayslipLabelValueTable.vue?vue&type=script&lang=js"

import "./PayslipLabelValueTable.vue?vue&type=style&index=0&id=527cdcec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cdcec"]])

export default __exports__